import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import "../App.css";
import BaseTemplate from "../layout/BaseTemplate";

export default function SubmitData() {
    return (
        <BaseTemplate>
            <Row>
                <Col>
                <h3>Upload your large-scale docking dataset to lsd.docking.org</h3>

                    <p>If you have published a large scale docking screen and would like us
                        to host it on lsd.docking.org, please fill in this form to tell us
                    about your dataset. We will be in touch with you within one week.</p>
                    <a href="https://tinyurl.com/mrb3wcak" target='_blank'><Button>Submit a request</Button></a>
                </Col>
            </Row>
        </BaseTemplate>
    );

}